import { createReducer, on, createFeatureSelector } from '@ngrx/store';
import { Pagination } from '../models/pagination.model';
import { Invitation } from '../models/invitation.model';
import { resetInvitations, setInvitations } from '../actions/invitations.actions';

export const initialState: Pagination<Invitation> = null;

const reducer = createReducer(initialState,
  on(setInvitations, (state, invitations) => invitations),
  on(resetInvitations, () => initialState),
);

export const fromInvitations = {
  selectInvitationsState: createFeatureSelector<Pagination<Invitation>>('invitations'),
};

export function invitationsReducer(state, action) {
  return reducer(state, action);
}
